/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Action_Bar_Playing_ParallelInputs */



/**
* | output |
* | --- |
* | "{count} rounds in progress. Finish rounds from the Rounds tab." |
*
* @param {Action_Bar_Playing_ParallelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_playing_parallel = /** @type {((inputs: Action_Bar_Playing_ParallelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Playing_ParallelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} rondes en cours. Terminez les rondes depuis l'onglet Rondes.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} rondas en curso. Finalice las rondas desde la pestaña Rondas.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} rodadas em andamento. Finalize as rodadas pela aba Rodadas.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} round in corso. Completa i round dalla scheda Round.`)
	return /** @type {LocalizedString} */ (`${i?.count} rounds in progress. Finish rounds from the Rounds tab.`)
});